import { render, staticRenderFns } from "./rename_folder_modal.vue?vue&type=template&id=29b40ee5&"
import script from "./rename_folder_modal.vue?vue&type=script&lang=js&"
export * from "./rename_folder_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports